import React, { useState } from "react";
// React-Bootstrap Imports
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipX from 'react-bootstrap/Tooltip';

// Local Component Imports
import AdminOffCanvas from "../components/AdminConsole";
import gear from "../images/gear.png";

// Note: Ensure these components exist or comment them out if not used yet
// import XAccess from "../components/XAccess";
// import XMembers from "../components/XMembers";
// import XDocz from "../components/XDocz";
// import XReportz from "../components/XReportz";

export default function AdminSite(props) {
    // Fixed: useState is now properly imported from 'react'
    const [showCanvas, setShowCanvas] = useState(false);
    
    const handleCloseCanvas = () => setShowCanvas(false);
    const handleShowCanvas = () => setShowCanvas(true);

    return (
        <>
            {/* Fixed: OverlayTrigger, TooltipX, and Button are now defined */}
            <OverlayTrigger 
                placement="top" 
                overlay={<TooltipX id="admin-tooltip">Admin Site Console</TooltipX>}
            >
               

                 <Button variant="primary" onClick={handleShowCanvas} className="hoverX">
                        <span className="circle-btn centerCircle">⚙️</span>Site
                    </Button>
            </OverlayTrigger>

            {/* Fixed: Offcanvas and AdminOffCanvas are now defined */}
            <Offcanvas 
                show={showCanvas} 
                onHide={handleCloseCanvas} 
                placement="end" 
                className="bg-dark"
                backdropClassName="adminBackdrop"
                
                style={{ height: '100vh' }}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <h3 className="modified xTitle animated rollIn">
                            Admin Site
                        </h3>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="padding">
                   
                        {/* This is the CRUD component we built previously */}
                        <AdminOffCanvas />
                  
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}